module.exports = __webpack_public_path__ + "fonts/SuisseIntl-BookItalic.7223c27.woff2";